import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { supabase } from "@/lib/supabase";

const AuthContext = createContext(null);
const initialRecovery = /type=recovery/.test(window.location.hash + window.location.search);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileError, setProfileError] = useState("");
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [recovery, setRecovery] = useState(initialRecovery);

  useEffect(() => {
    let alive = true;
    supabase.auth.getSession().then(({ data }) => {
      if (alive) { setSession(data.session); setLoading(false); }
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, next) => {
      if (!alive) return;
      if (event === "PASSWORD_RECOVERY") setRecovery(true);
      setSession(next);
    });
    return () => { alive = false; subscription.unsubscribe(); };
  }, []);

  const userId = session?.user?.id;
  useEffect(() => {
    if (!userId) { setProfile(null); setProfileError(""); setProfileLoaded(false); return; }
    let alive = true;
    setProfileLoaded(false);
    supabase.from("profiles").select("*").eq("id", userId).maybeSingle()
      .then(({ data, error }) => {
        if (!alive) return;
        if (error) setProfileError(error.message);
        else if (!data) setProfileError("Tu usuario no tiene un perfil con taller asignado.");
        else { setProfile(data); setProfileError(""); }
        setProfileLoaded(true);
      });
    return () => { alive = false; };
  }, [userId]);

  const value = useMemo(() => ({
    session, profile, loading, profileError, profileLoaded, active: profile?.activo === true,
    recovery, finishRecovery: () => setRecovery(false),
    signOut: () => supabase.auth.signOut({ scope: "local" }),
  }), [session, profile, loading, profileError, profileLoaded, recovery]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
